/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2021, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

import * as _ from 'underscore';
import { Logger } from '@core/lib/services';
import { NPRAuthentication } from '@app/di/security/npr-authentication.service';
import { SRClientService, MessageType } from '@app/di/integrations/reporting/smartreports/sr-client.service';
import { UserPreferenceService } from '@app/common/user-preference.service';
import { NotifyService } from '@app/common/notify.service';
import { TranslateService } from '@ngx-translate/core';
import { PostMessengerService } from '@app/di/channel/window/post-messenger.service';

const log = new Logger('SRAdminSettingsService');

export class SRAdminSettingsService extends SRClientService {
  private userPreferenceService: UserPreferenceService;
  private notify: NotifyService;
  private translate: TranslateService;

  constructor(
    authenticator: NPRAuthentication,
    userPreferenceService: UserPreferenceService,
    notify: NotifyService,
    translate: TranslateService,
    postMessengerService: PostMessengerService
  ) {
    super('AdminPanel', authenticator, postMessengerService);
    this.userPreferenceService = userPreferenceService;
    this.notify = notify;
    this.translate = translate;
    this.onready = () => this.showAdminPanel();
  }

  private showAdminPanel() {
    log.debug('launching Admin Panel');
    const department = this.userPreferenceService.getSRDepartment();
    if (department) {
      this.sendRequest(MessageType.OpenAdminPanel, { department: department })
        .then(() => this.showContents())
        .catch(error => log.error('launching Admin Panel failed : ', error));
    } else {
      this.notify.error(this.translate.instant('sr.department.missing'));
    }
  }
}
